import type { GroupDeal, RboConfig } from '@openx/types/deal';
import { rboConfigTactic } from '@openx/types/rbo';

// Fixed on this save does not recalc. A stored Dynamic group still does, and so
// does switching a stored non-dynamic group to Dynamic. An empty group does not,
// so creating a deal does not prompt on tactic alone.
export const isDynamicRboThatNeedsRecalc = (
  storedGroup: Array<Pick<GroupDeal, 'rboConfig'>> | null | undefined,
  pendingRboConfig: RboConfig | undefined
): boolean => {
  if (pendingRboConfig?.tactic === rboConfigTactic.FIXED) return false;

  const storedIsDynamic = !!storedGroup?.some(deal => deal.rboConfig?.tactic === rboConfigTactic.DYNAMIC);
  if (storedIsDynamic) return true;

  return pendingRboConfig?.tactic === rboConfigTactic.DYNAMIC && !!storedGroup?.length;
};
